import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebaseConfig"; // Adjust the import path according to your project structure

const indexedObjectToArray = (obj) => {
  if (!obj || typeof obj !== "object") return [];
  return Object.keys(obj)
    .filter((k) => String(Number(k)) === k) // only numeric keys
    .sort((a, b) => Number(a) - Number(b))
    .map((k) => obj[k]);
};

async function readDataS1() {
  const user = auth.currentUser; // Get the current user from the context
  if (!user) {
    throw new Error("User is not authenticated.");
  }

  const userId = user.uid;

  if (!userId)
    throw new Error("No user selected. Please select an application first.");

  try {
    const personalRef = doc(db, "Advisers", userId, "Personal Details", "Data");
    const applicationRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Data",
    );
    const prevRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Previous Addresses",
    );
    const nokRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Next of Kin Details",
    );

    const [personalSnap, appSnap, prevSnap, nokSnap] = await Promise.all([
      getDoc(personalRef),
      getDoc(applicationRef),
      getDoc(prevRef),
      getDoc(nokRef),
    ]);

    if (
      !personalSnap.exists() &&
      !appSnap.exists() &&
      !prevSnap.exists() &&
      !nokSnap.exists()
    ) {
      return null;
    }

    const prevRaw = prevSnap.exists() ? prevSnap.data() : null;

    // if it was saved as numeric keys -> object -> array
    // if it was saved as {addresses:[...]} -> still supported
    const previousAddress = Array.isArray(prevRaw?.addresses)
      ? prevRaw.addresses
      : indexedObjectToArray(prevRaw);

    return {
      personalDetails: personalSnap.exists() ? personalSnap.data() : {},
      previousAddress,
      nextOfKinDetails: nokSnap.exists() ? nokSnap.data() : {},
      applicationDetails: appSnap.exists() ? appSnap.data() : {},
    };
  } catch (error) {
    return null;
  }
}

export const getDataS1 = async () => readDataS1();